// ============================================================
// CONFIGURAZIONE TEMPIO VIVO — punti da sostituire con asset reali
// ============================================================

// WhatsApp reale dei Founder con messaggio di benvenuto precompilato.
// Per cambiare numero o testo, modifica qui: tutte le CTA si aggiornano da sole.
const WHATSAPP_NUMBER = "35677152198";
const WHATSAPP_MESSAGE =
  "Ciao Elio e Chiara! Ho visto la pagina di Tempio Vivo e vorrei scoprire se è il percorso giusto per me.";

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

// Link Calendly per prenotare la Mappa del Tempio (incontro 30 min con Elio).
// Se svuotato, i pulsanti tornano ad aprire WhatsApp come ripiego.
export const CALENDLY_URL = "https://calendly.com/briottielio/mappadeltempio";
export const MAPPA_URL = CALENDLY_URL || WHATSAPP_URL;

// Messaggio precompilato dopo l'invio del questionario (backend ancora attivo)
export const whatsappAfterQuestionnaire = (name) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    `Ciao Elio, ho appena compilato il questionario Tempio Vivo. Mi chiamo ${name} e vorrei approfondire il percorso.`
  )}`;

// Qualifiche reali e documentate dei coach (pubblicate SOLO se compilate).
// Esempio: { title: "Life Coaching Certification", issuer: "Ente", year: "2024" }
export const QUALIFICATIONS = [];

// Asset visivi. Sostituire gli URL con file reali in /public/assets quando disponibili.
export const ASSETS = {
  // Fotografia cinematografica hero (silhouette in movimento)
  heroBg:
    "https://images.unsplash.com/photo-1775225218513-4395fef99aea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBmaXRuZXNzJTIwc2lsaG91ZXR0ZXxlbnwwfHx8fDE3ODc1ODc2NjV8MA&ixlib=rb-4.1.0&q=85",
  // Community / incontro reale
  community:
    "https://images.pexels.com/photos/1581554/pexels-photo-1581554.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  // Bibbia elegante
  bible:
    "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwYmlibGUlMjByZWFkaW5nfGVufDB8fHx8MTc4NzU4NzY2NXww&ixlib=rb-4.1.0&q=85",
  // Territorio / cammino in città italiana
  territory:
    "https://images.unsplash.com/photo-1650317114682-a579ec7b7c1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxpdGFsaWFuJTIwc3RyZWV0JTIwd2Fsa2luZyUyMGZyaWVuZHN8ZW58MHx8fHwxNzg3NTg3NjY2fDA&ixlib=rb-4.1.0&q=85",
  // PLACEHOLDER FOUNDER: inserire URL fotografie reali (null = cornice placeholder elegante)
  // Screenshot reali dell'app Tempio Vivo (in /public/assets/app/)
  appHome: "/assets/app/home.jpeg",
  appTempio: "/assets/app/tempio.jpeg",
  appOggi: "/assets/app/oggi.jpeg",
  appGuerriero: "/assets/app/guerriero.webp",
  // Fotografie reali dei Founder (caricate in /public/assets/founders/)
  elioPhoto: "/assets/founders/elio.webp",
  chiaraPhoto: "/assets/founders/chiara.webp",
  couplePhoto: "/assets/founders/coppia.jpeg",
  coupleSelfie: "/assets/founders/coppia-selfie.jpeg",
  elioBefore: "/assets/founders/elio-108.webp",
  elioAfter: "/assets/founders/elio-75.webp",
  chiaraBefore: "/assets/founders/chiara-prima.webp",
  chiaraAfter: "/assets/founders/chiara-oggi.webp",
  // VSL dei Founder — embed YouTube (autoplay solo al click sul play)
  vslUrl: "https://www.youtube.com/embed/8eZilUzZAKI",
};

export const scrollToId = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.5 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

// Punti della mappa territorio. Modifica liberamente:
// type = "connect" (Connect Group) | "ambassador" (Ambassador) | "soon" (In arrivo)
// coords = [latitudine, longitudine]
// NOTA: zone Connect attualmente illustrative / in fase di verifica.
export const LOCATIONS = [
  // NORD
  { city: "Torino", type: "connect", coords: [45.0703, 7.6869], note: "Zona in verifica" },
  { city: "Biella", type: "connect", coords: [45.5663, 8.0536], note: "Zona in verifica" },
  { city: "Milano", type: "connect", coords: [45.4642, 9.19], note: "Zona in verifica" },
  { city: "Bologna", type: "connect", coords: [44.4949, 11.3426], note: "Zona in verifica" },
  // CENTRO
  { city: "Firenze", type: "connect", coords: [43.7696, 11.2558], note: "Zona in verifica" },
  { city: "Roma", type: "connect", coords: [41.9028, 12.4964], note: "Zona in verifica" },
  // SUD
  { city: "Aversa", type: "connect", coords: [40.9726, 14.2049], note: "Zona in verifica" },
  { city: "Bari", type: "connect", coords: [41.1171, 16.8719], note: "Zona in verifica" },
  { city: "Nardò", type: "connect", coords: [40.1795, 18.0331], note: "Zona in verifica" },
  // ISOLE
  { city: "Palermo", type: "connect", coords: [38.1157, 13.3615], note: "Zona in verifica" },
  { city: "Catania", type: "connect", coords: [37.5079, 15.083], note: "Zona in verifica" },
];
